/**
 * Authentication service for axios interceptor
 */
class AuthService {
  constructor() {
    this.token = null
  }

  setToken(token) {
    this.token = token
  }

  getToken() {
    return this.token
  }

  clearToken() {
    this.token = null
  }
}

export const authService = new AuthService()
